import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { inject, InjectionToken } from "@angular/core";
import { SIGN_IN_REDIRECT, SignInRedirect } from "./sign-in-redirect";
import { clearReturnPath, takeReturnTarget } from "./return-path";

// The dashboard receives the website's token in its address (?token=). The website stores a token only from a sign-in
// it started (signed-in.guard.ts): for it, a token in the address is one anyone could have put there.
export const ACCEPTS_TOKEN_IN_ADDRESS = new InjectionToken<boolean>("ACCEPTS_TOKEN_IN_ADDRESS", {
    factory: (): boolean => false,
});

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const acceptsTokenInAddress: boolean = inject(ACCEPTS_TOKEN_IN_ADDRESS);
    if (!acceptsTokenInAddress && (route.queryParamMap.has("token") || route.queryParamMap.has("user_id"))) {
        // Removed so that the address is not copied or bookmarked with it; replaced in history too.
        const address = inject(Router).parseUrl(state.url);
        delete address.queryParams["token"];
        delete address.queryParams["user_id"];
        return new RedirectCommand(address, { replaceUrl: true });
    }

    const queryToken: string | null = route.queryParams["token"];
    const queryUserId: string | null = route.queryParams["user_id"];
    if (queryToken && queryToken.length > 0) {
        localStorage.setItem("token", queryToken);
        if (queryUserId && queryUserId.length > 0) {
            localStorage.setItem("userId", queryUserId);
        }
        return takeReturnTarget(inject(Router));
    }

    const token: string | null = localStorage.getItem("token");
    if (token && token.length > 0) {
        // A path saved before a sign-in that came back another way would fire at this tab's next ?token=.
        clearReturnPath();
        return true;
    }

    const redirectToSignIn: SignInRedirect = inject(SIGN_IN_REDIRECT);
    const errorCode: string | undefined = route.queryParams["errorcode"];
    redirectToSignIn(
        state.url,
        errorCode ? { errorcode: errorCode, errordescription: route.queryParams["errordescription"] } : undefined,
    );

    return false;
};
